import API from '../../sunwiseAPI';
const ENTITY = 'rate-list';

export const getRates = (companyId) =>
    API.get(`/api/v2/${ENTITY}/public/`, {
        params: { company: companyId },
    });
